import { render } from "./Tabs.vue?vue&type=template&id=1bde2e68&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=1bde2e68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bde2e68"]])

export default __exports__